import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Checkbox,
   CircularProgress,
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import previewIcon from "../../../../src/assets/preview.png"
import healthpartner from "../../../../src/assets/healthpartner.png"
import imedxlogo from "../../../../src/assets/logoImedx.png"
import { generateClinicalDocumentationPDF } from "./generateClinicalDocumentationPDF";
import { setCdqRequest } from "../Redux/EpisodeStatusSlice";
import { useDispatch } from "react-redux";
// import { generateClinicalDocumentationPDF } from "./pdfGenerator";
const TEAL = "#5CB9B3";
const NAVY = "#003B75";
const BORDER = "#E2E8F0";
const LABEL_GRAY = "#4A9EB1";
const TEXT_DARK = "#101828";

// Small reusable label used above every input / field group
const FieldLabel = ({ children }) => (
  <Typography
    sx={{
      fontSize: "11px",
      fontWeight: 700,
      letterSpacing: "0.5px",
      color: "#64748B",
      mb: 0.8,
    }}
  >
    {children}
  </Typography>
);

const ClinicalDocumentationQuery = ({ open, onClose, onSendQuery, episode, onPreview, cdqTemplateDetails, selectedEpisode, clinician, onClearFiles, specialtyService, setSpecialtyService, setClinicianEmail,
  clinicianEmail, setClinician, isSendingCDQ, }) => {
  const [responseOption, setResponseOption] = useState("");
  const [otherText, setOtherText] = useState("");
  const [clinicianName, setClinicianName] = useState("");
  const [clinicianSpecialty, setClinicianSpecialty] = useState("");
  const [responseDate, setResponseDate] = useState("");
  const [responseTime, setResponseTime] = useState("");
  const [responseOptions, setResponseOptions] = useState([]);
  const [category, setCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [queryText, setQueryText] = useState("");
  const [editingQuery, setEditingQuery] = useState(false);
const [editingResponseOption, setEditingResponseOption] = useState(null);

  const dispatch = useDispatch()

  // Fallback demo data — pass a real `episode` prop to override

  const data = {
    mrn: selectedEpisode?.medical_record_number,
    episodeId: selectedEpisode?.episode_identifier,
    hospital: "North Metro Hospital",
    los: selectedEpisode?.length_of_stay,
    admissionDate: selectedEpisode?.admission_date,
    separationDate: selectedEpisode?.separation_date,
    clinician: cdqTemplateDetails?.clinician_to_sent_info
      ?.responding_clinician || "",
    specialty: specialtyService,
    generatedBy: sessionStorage.getItem("username") || "",
    generatedOn: new Date().toLocaleDateString("en-GB"),
    ...episode,
  };



  const handlePreview = () => {
    generateClinicalDocumentationPDF({
      mrn: data.mrn,
      episodeId: data.episodeId,
      hospital: data.hospital,
      los: data.los,
      admissionDate: data.admissionDate,
      separationDate: data.separationDate,
      clinician: data.clinician,
      specialty: data.specialty,

      category,
      responseOption,
      otherText,
      clinicianName,
      clinicianSpecialty,
      responseDate,
      responseTime,

      generatedBy: data.generatedBy,
      generatedOn: data.generatedOn,
    });
  };


  // useEffect(() => {
  //   if (!cdqTemplateDetails) return;

  //   // CDQ Category
  //   const categories = (
  //     cdqTemplateDetails.cdq_category || []
  //   ).map((item) => ({
  //     ...item,
  //     display_name: item.display_name || "",
  //     is_selected: Boolean(item.is_selected),
  //   }));

  //   setCategoryOptions(categories);

  //   // Set currently selected category
  //   const selectedCategory = categories.find(
  //     (item) => item.is_selected
  //   );

  //   setCategory(
  //     selectedCategory?.display_name || ""
  //   );

  //   // Response Options
  //   setResponseOptions(
  //     (cdqTemplateDetails.response_options || []).map(
  //       (item) => ({
  //         ...item,
  //         display_name:
  //           item.display_name || item.option || "",
  //         is_selected: Boolean(item.is_selected),
  //       })
  //     )
  //   );
  //      setQueryText(cdqTemplateDetails?.query || "");
  //   // Clinician information
  //   setClinicianName("");

  //   setClinicianSpecialty("");
  // }, [cdqTemplateDetails]);

  useEffect(() => {
    if (!cdqTemplateDetails) return;

    // CDQ Category
    const categories = (
      cdqTemplateDetails.cdq_category || []
    ).map((item) => ({
      ...item,
      display_name: item.display_name || "",
      is_selected: Boolean(item.is_selected),
    }));

    setCategoryOptions(categories);

    // Set currently selected category
    const selectedCategory = categories.find(
      (item) => item.is_selected
    );

    setCategory(
      selectedCategory?.display_name || ""
    );

    // Response Options
    const isOtherTemplate =
      cdqTemplateDetails?.template_name === "Other";

    setResponseOptions(
      (cdqTemplateDetails.response_options || []).map((item) => ({
        ...item,
        display_name:
          item.display_name || item.option || "",
        is_selected: isOtherTemplate
          ? false
          : Boolean(item.is_selected),
      }))
    );

    setQueryText(cdqTemplateDetails?.query || "");

    // Clinician information
    setClinicianName("");
    setClinicianSpecialty("");

  }, [cdqTemplateDetails]);
  const handleSendQuery = () => {
    // Send ALL response options
    const finalResponseOptions = responseOptions.map((item) => ({
      option: item.option,
      display_name: item.display_name,
      is_selected: Boolean(item.is_selected),
      priority: item.priority,
    }));

    // Send ALL categories also
    const finalCategories = categoryOptions.map((item) => ({
      display_name: item.display_name,
      is_selected: item.display_name === category,
      priority: item.priority,
    }));

    const updatedCdqRequest = {
      template_name:
        cdqTemplateDetails?.template_name || "",

      clinician_to_sent_info: {
        // User-entered value only
        responding_clinician: clinician || "",

        email:
          cdqTemplateDetails?.clinician_to_sent_info?.email || "",

        specialty: specialtyService || "",
      },

      // ALL categories
      cdq_category: finalCategories,

      query: queryText || "",

      // ALL response options
      response_options: finalResponseOptions,
    };

    console.log(
      "FINAL CDQ REQUEST:",
      JSON.stringify(updatedCdqRequest, null, 2)
    );

    dispatch(setCdqRequest(updatedCdqRequest));

    onSendQuery?.(updatedCdqRequest);
    // setClinicianEmail("")
    // setClinician("")
    // setSpecialtyService("")

    // onClose();
  };

  return (
    <Dialog
      open={open}
       onClose={isSendingCDQ ? undefined : onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
          width: "660px",
          maxWidth: "94vw",
          height: "820px",
          maxHeight: "94vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          flexShrink: 0,
          bgcolor: "#fff",
          borderBottom: `1px solid ${BORDER}`,
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Logo */}
        <Box component={"img"} src={imedxlogo} sx={{ height: "42px", width: "95px" }} />



        {/* Title */}
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "0.8px",
              color: TEAL,
            }}
          >
            CLINICAL DOCUMENTATION QUERY
          </Typography>
          <Typography sx={{ fontSize: "11px", color: "#64748B", mt: 0.3, textAlign: "center" }}>
            {cdqTemplateDetails?.template_name === "Other"
              ? "OTHER"
              : "Ambiguous Documentation Clarification"}
          </Typography>
        </Box>

        {/* Health partner + icon */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: "90px", justifyContent: "flex-end" }}>
          <Typography sx={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px", color: TEXT_DARK }}>
            HEALTH PARTNER
          </Typography>
          <img
            src={healthpartner}
            style={{ height: "35px", width: "35px" }}
          >
            {/* <GridViewIcon sx={{ fontSize: 16, color: "#667085" }} /> */}
          </img>
        </Box>
      </Box>

      {/* Scrollable body */}
      <DialogContent sx={{ px: 3, py: 2.5, flex: 1, overflowY: "auto" }}>
        {/* Episode info grid */}
        <Box
          sx={{
            bgcolor: "#F8FAFC",
            border: `1px solid ${BORDER}`,
            borderRadius: "8px",
            p: 2.5,
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            columnGap: "16px",
            rowGap: "18px",
            mb: 2.5,
          }}
        >
          <Box>
            <FieldLabel>MRN</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.mrn}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>EPISODE ID</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.episodeId}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>HOSPITAL</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.hospital}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>LENGTH OF STAY</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.los}
            </Typography>
          </Box>

          <Box>
            <FieldLabel>ADMISSION DATE</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.admissionDate}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>SEPARATION DATE</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.separationDate}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>CLINICIAN</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.clinician}
            </Typography>
          </Box>
          <Box>
            <FieldLabel>SPECIALTY</FieldLabel>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: TEXT_DARK }}>
              {data.specialty}
            </Typography>
          </Box>
        </Box>

        {/* Info banner */}
        <Box
          sx={{
            bgcolor: "#4A9EB11A",
            borderLeft: `3px solid ${"#1FC0B6"}`,
            borderRadius: "6px",
            p: 1.8,
            display: "flex",
            gap: 1.2,
            alignItems: "flex-start",
            mb: 3,
          }}
        >
          <InfoIcon sx={{ fontSize: 19, color: "#4A9EB1", mt: "1px" }} />
          <Typography sx={{ fontSize: "12.5px", color: "#4A9EB1", lineHeight: 1.6 }}>
            Patient Episode ID {data.episodeId}, MRN {data.mrn} was admitted to{" "}
            {data.hospital} on {data.admissionDate}. Please review the available
            documentation in your organisation systems to complete the Clinical
            Documentation Query below.
          </Typography>
        </Box>

        {/* CDQ Category */}
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 700,
            color: TEXT_DARK,
            mb: 1,
          }}
        >
          CDQ Category
        </Typography>

        <RadioGroup
          row
          value={category}
          onChange={(e) => {
            const selectedValue = e.target.value;

            // Single source of truth
            setCategory(selectedValue);
          }}
          sx={{
            mb: 3,
            flexWrap: "wrap",
          }}
        >
          {categoryOptions.map((item) => (
            <FormControlLabel
              key={item.priority}
              value={item.display_name}
              control={
                <Radio
                  size="small"
                  checked={category === item.display_name}
                  sx={{
                    color: "#CBD5E1",
                    "&.Mui-checked": {
                      color: TEAL,
                    },
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: "12.5px",
                    fontWeight:
                      category === item.display_name ? 600 : 400,
                    color:
                      category === item.display_name
                        ? TEXT_DARK
                        : LABEL_GRAY,
                  }}
                >
                  {item.display_name}
                </Typography>
              }
              sx={{ mr: 2.5 }}
            />
          ))}
        </RadioGroup>

        {/* Query */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  }}
>
  <Typography
    sx={{
      fontSize: "13px",
      fontWeight: 700,
      color: TEXT_DARK,
    }}
  >
    Query
  </Typography>

  <IconButton
    size="small"
    onClick={() => setEditingQuery((prev) => !prev)}
    sx={{
      color: editingQuery ? TEAL : "#667085",
      p: 0.5,
    }}
  >
    {editingQuery ? (
      <CheckIcon sx={{ fontSize: 18 }} />
    ) : (
      <EditIcon sx={{ fontSize: 18 }} />
    )}
  </IconButton>
</Box>

<Box
  sx={{
    border: `1px solid ${BORDER}`,
    borderRadius: "8px",
    p: 1,
    mb: 3,
    bgcolor: editingQuery ? "#fff" : "#F8FAFC",
  }}
>
  <TextField
    fullWidth
    multiline
    minRows={1}
    value={queryText}
    disabled={!editingQuery}
    onChange={(e) => setQueryText(e.target.value)}
    placeholder="Enter query..."
    variant="outlined"
    sx={{
      "& .MuiOutlinedInput-root": {
        fontSize: "13px",
        color: "#475467",
        lineHeight: 1.6,

        "& fieldset": {
          border: "none",
        },
      },
    }}
  />
</Box>

        {/* Response Options */}
        {/* Response Options */}
        {/* Response Options Header */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  }}
>
  <Typography
    sx={{
      fontSize: "13px",
      fontWeight: 700,
      color: TEXT_DARK,
    }}
  >
    Response Options
  </Typography>
</Box>

<Box
  sx={{
    bgcolor: "#FFF8E7",
    border: "1px solid #F5D98B",
    borderRadius: "6px",
    px: 1.5,
    py: 1,
    mb: 1.5,
  }}
>
  <Typography
    sx={{
      fontSize: "11.5px",
      color: "#8A6500",
      lineHeight: 1.5,
    }}
  >
    Note:Only the clinician should provide a response. Coder input is not required for this section. However, the coder may edit the text for clarification or correction before submitting
  </Typography>
</Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            mb: 3,
          }}
        >
         {responseOptions.map((item, index) => {
  const isEditing = editingResponseOption === index;

  return (
    <Box
      key={item.option || index}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: "100%",
      }}
    >
      {/* Checkbox */}
      <Checkbox
        size="small"
        checked={Boolean(item.is_selected)}
        disabled
        sx={{
          p: 0.5,
          color: "#CBD5E1",
          "&.Mui-checked": {
            color: TEAL,
          },
          "&.Mui-disabled": {
            color: item.is_selected ? TEAL : "#CBD5E1",
          },
        }}
      />

      {/* Response Option */}
      <TextField
        fullWidth
        size="small"
        value={item.display_name}
        disabled={!isEditing}
        onChange={(e) => {
          const value = e.target.value;

          setResponseOptions((prev) =>
            prev.map((option, optionIndex) =>
              optionIndex === index
                ? {
                    ...option,
                    display_name: value,
                  }
                : option
            )
          );
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "34px",
            bgcolor: isEditing ? "#fff" : "#F8FAFC",
            borderRadius: "6px",
            fontSize: "13px",

            "& fieldset": {
              borderColor: BORDER,
            },

            "&:hover fieldset": {
              borderColor: isEditing ? "#98A2B3" : BORDER,
            },

            "&.Mui-focused fieldset": {
              borderColor: NAVY,
            },
          },
        }}
      />

      {/* Edit / Save */}
      <IconButton
        size="small"
        onClick={() =>
          setEditingResponseOption(isEditing ? null : index)
        }
        sx={{
          p: 0.5,
          color: isEditing ? TEAL : "#667085",
          flexShrink: 0,
        }}
      >
        {isEditing ? (
          <CheckIcon sx={{ fontSize: 18 }} />
        ) : (
          <EditIcon sx={{ fontSize: 18 }} />
        )}
      </IconButton>
    </Box>
  );
})}
        </Box>

        {/* Responding clinician / specialty */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "20px",
            mb: 2.5,
          }}
        >
          <Box>
            <FieldLabel>RESPONDING CLINICIAN</FieldLabel>
            <TextField
              fullWidth
              size="small"
              disabled
              placeholder="Clinician name..."
              value={clinicianName}
              onChange={(e) => setClinicianName(e.target.value)}
              InputProps={{
                sx: {
                  fontSize: "13px",
                  bgcolor: "#F8FAFC",
                  borderRadius: "6px",
                  "& fieldset": { borderColor: BORDER },
                },
              }}
            />
          </Box>
          <Box>
            <FieldLabel>CLINICIAN SPECIALTY</FieldLabel>
            <TextField
              fullWidth
              size="small"
              disabled
              placeholder="Specialty..."
              value={clinicianSpecialty}
              onChange={(e) => setClinicianSpecialty(e.target.value)}
              InputProps={{
                sx: {
                  fontSize: "13px",
                  bgcolor: "#F8FAFC",
                  borderRadius: "6px",
                  "& fieldset": { borderColor: BORDER },
                },
              }}
            />
          </Box>
        </Box>

        {/* Response date / time */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "20px",
            mb: 2.5,
          }}
        >
          <Box>
            <FieldLabel>RESPONSE DATE</FieldLabel>
            <TextField
              fullWidth
              size="small"
              disabled
              type="date"
              placeholder="dd/mm/yyyy"
              value={responseDate}
              onChange={(e) => setResponseDate(e.target.value)}
              InputProps={{
                sx: {
                  fontSize: "13px",
                  bgcolor: "#F8FAFC",
                  borderRadius: "6px",
                  "& fieldset": { borderColor: BORDER },
                },
              }}
            />
          </Box>
          <Box>
            <FieldLabel>RESPONSE TIME</FieldLabel>
            <TextField
              fullWidth
              size="small"
              disabled
              placeholder="--:--"
              value={responseTime}
              onChange={(e) => setResponseTime(e.target.value)}
              InputProps={{
                sx: {
                  fontSize: "13px",
                  bgcolor: "#F8FAFC",
                  borderRadius: "6px",
                  "& fieldset": { borderColor: BORDER },
                },
              }}
            />
          </Box>
        </Box>

        {/* Generated by / on */}
        <Box
          sx={{
            borderTop: `1px solid ${BORDER}`,
            pt: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: "12px", color: LABEL_GRAY }}>
            Generated By:{" "}
            <Typography component="span" sx={{ fontSize: "12px", fontWeight: 600, color: TEXT_DARK }}>
              {data.generatedBy}
            </Typography>
          </Typography>
          <Typography sx={{ fontSize: "12px", color: LABEL_GRAY }}>
            Generated On:{" "}
            <Typography component="span" sx={{ fontSize: "12px", fontWeight: 600, color: TEXT_DARK }}>
              {data.generatedOn}
            </Typography>
          </Typography>
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          flexShrink: 0,
          bgcolor: "#F5F7FB",
          borderTop: `1px solid ${BORDER}`,
          px: 3,
          py: 2,
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={handlePreview}
          startIcon={<img src={previewIcon} sx={{ fontSize: 16 }} />}
          sx={{
            color: TEXT_DARK,
            bgcolor: "#fff",
            border: `1px solid ${BORDER}`,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "13px",
            px: 2,
            "&:hover": { bgcolor: "#F8FAFC" },
          }}
        >
          Preview
        </Button>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Cancel */}
          <Button
            onClick={onClose}
            disabled={isSendingCDQ}
            sx={{
              color: NAVY,
              bgcolor: "#fff",
              border: `1px solid ${BORDER}`,
              px: 3,
              py: 1,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "13px",
              borderRadius: "6px",
              "&:hover": {
                bgcolor: "#F8FAFC",
              },
            }}
          >
            Cancel
          </Button>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              onClick={handleSendQuery}
              // endIcon={<ArrowForwardIcon sx={{ fontSize: 15 }} />}
               endIcon={
    isSendingCDQ ? (
      <CircularProgress size={16} sx={{ color: "#fff" }} />
    ) : (
      <ArrowForwardIcon sx={{ fontSize: 15 }} />
    )
  }
              sx={{
                bgcolor: "#002B55",
                px: 3,
                py: 1,
                color: "#fff",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "13px",
                borderRadius: "6px",
                "&:hover": { bgcolor: "#002B55", color: "#fff", },
              }}
            >
               {isSendingCDQ ? "Sending..." : "Send Query"}
              {/* Send Query */}
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ClinicalDocumentationQuery;